import { apiClient } from "../apiClient";

export const khoiApi = {
    getAll: () => apiClient.get(`khoi`)
}